import React from "react";
import Select from "react-select";
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #EAEBEF",
        padding: 10,
        fontSize: 14,
        color: "#58585B",
    }),
    control: () => ({
        width: "100%",
    }),
};
export default class SelectDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCLose: true,
        };
    }
    render() {
        return (
            <Select
                className={
                    this.state.menuCLose ? "custom-slect" : "active-slect"
                }
                styles={customStyles}
                name={this.props.name}
                placeholder={this.props.placeholder}
                defaultValue={this.props.options.find(
                    (option) => option.value === this.props.value,
                )}
                onChange={(event) => this.props.handleChange(event)}
                isInvalid={this.props.touched && !this.props.errors}
                options={this.props.options}
                onMenuClose={(e) => this.setState({ menuCLose: true })}
                onMenuOpen={(e) => this.setState({ menuCLose: false })}
            />
        );
    }
}
